import { useSelector } from 'react-redux';
import { getFundDetailsData, getSelectedShareClass } from '@/store/fundDetails';
import { useMemo } from 'react';
import { useSitecoreContext } from './useSitecoreContext';

const usePayload = () => {
  const shareClasses = useSelector(getSelectedShareClass);
  const fundDetailsData = useSelector(getFundDetailsData);
  const { sitecoreContext: context } = useSitecoreContext();
  const {
    fundsConfiguration: {
      countryInvestors: { countryCode, literatureAuthorization, investorType, jurisdiction },
    },
    language = '',
    site: { name },
  } = context;

  return useMemo(() => {
    return {
      countryCode,
      language,
      shareClass: shareClasses?.id,
      assetClassId: fundDetailsData.assetClassId,
      fund: fundDetailsData.fundId,
      correlationFundRangeId: fundDetailsData.correlationFundRangeID,
      fundRangeName: fundDetailsData.fundRangeName,
      fundName: fundDetailsData.name,
      fundNameId: fundDetailsData.fundNameId,
      shareClassNameId: fundDetailsData.shareClassNameId,
      literatureAuthorizations: [literatureAuthorization],
      sfdrClassificationId: fundDetailsData.sfdrClassificationId,
      countryInvestors: {
        countryCode: countryCode,
        investorType: investorType,
        jurisdiction: jurisdiction,
      },
      site: name,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context, fundDetailsData]);
};

export default usePayload;
